const PROFILE = import.meta.env.VITE_APP_PROFILE || "default";

// Route `name` values to exclude per profile.
// These must match the `name` field in router.link.jsx route definitions.
const EXCLUDED_ROUTES = {
  supermarket: new Set([
    "repairs",
    "repair-pos",
    "repair-dashboard",
    "repair-categories",
    "add-repair",
    "edit-repair",
    "predefined-repairs",
    "add-predefined-repair",
    "edit-predefined-repair",
    "special-parts",
    "tasks",
    "parts-usage-report",
    "tenant-settings",
  ]),
};

// Entire sidebar nav group labels to hide per profile.
const EXCLUDED_NAV_GROUPS = {
  supermarket: new Set(["Repairs"]),
};

// Individual sidebar nav item titles to hide per profile.
const EXCLUDED_NAV_ITEMS = {
  supermarket: new Set(["Tasks", "Parts Usage", "Tenant Settings"]),
};

export const hiddenRoutes = EXCLUDED_ROUTES[PROFILE] ?? new Set();
export const hiddenNavGroups = EXCLUDED_NAV_GROUPS[PROFILE] ?? new Set();
export const hiddenNavItems = EXCLUDED_NAV_ITEMS[PROFILE] ?? new Set();
